import { useEffect, useState } from "react"
import LoadingSpinner from '../../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./../toastify/config";
import apiCumbres from "../../axios/axios";
import { motion } from "motion/react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, Box } from "@mui/material";
import { sxTableHead } from "../Styles";


const Morosos = () => {

    const [isLoading, setIsLoading] = useState(false)

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [clientesMorosos, setClientesMorosos] = useState([])


    const obtenerMorosos = () => {

        const obteniendoMorosos = async () => {


            try {
                setIsLoading(true)

                const obteniendo = await apiCumbres.get('/reportes/morosos/obtener')
                const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']
                obteniendo.data.forEach((c) => {
                    const dfa = new Date(c.fechaAbono + ' 08:00:00')
                    c.fechaAbono = `${dfa.getDate().toString().padStart('2', 0)} DEL ${meses[dfa.getMonth()]} DEL ${dfa.getFullYear()}`
                })

                setClientesMorosos(obteniendo.data)

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener información de morosos, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        obteniendoMorosos()

    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    useEffect(() => {
        obtenerMorosos()
    }, [])

    return (
        <>
            <div className="container">
                {isLoading ?
                    <LoadingSpinner />
                    : null}

                <div className="row">


                    <motion.div
                        className="col-md-12 mt-3"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}
                    >
                        <TableContainer component={Paper} sx={{
                            width: "100%",
                            overflowX: "auto",   // 🔥 horizontal
                            overflowY: "visible",
                        }}>
                            <Table >
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                        <TableCell sx={sxTableHead}>#</TableCell>
                                        <TableCell sx={sxTableHead}>Cliente</TableCell>
                                        <TableCell sx={sxTableHead}>Abono retrasado</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {clientesMorosos
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((cli, index) => (
                                            <motion.tr
                                                key={index}
                                                initial={{ opacity: 0, x: -50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                exit={{ opacity: 0, y: -40 }}
                                                transition={{
                                                    duration: 0.4,
                                                    ease: "easeOut",
                                                    delay: 0.1 * index
                                                }}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                }}
                                            >
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{cli['contratos_prestamo.cliente.nombre_completo']}</TableCell>
                                                <TableCell>{cli.fechaAbono}</TableCell>

                                            </motion.tr>
                                        ))}
                                </TableBody>
                            </Table>
                            <Box sx={{ flexShrink: 0 }}>
                                <TablePagination
                                    component="div"
                                    count={clientesMorosos.length}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Registros por página"
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                />
                            </Box>

                        </TableContainer>
                    </motion.div>




                </div>

                <ToastContainer
                    transition={Flip}
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored" />

            </div>
        </>
    )

}


export default Morosos